export default __webpack_public_path__ + "static/media/tempustitlescreen.35615e77.png";